import {Fill, Stroke, Style} from "ol/style";

export const whiteStroke = new Stroke({
  color: 'white',
});

export const defaultStyle = new Style({
  fill: new Fill({
    color: '#e5e5e5',
  }),
  stroke: whiteStroke
});

export const correctStyle = new Style({
  fill: new Fill({
    color: '#bdde78', // equal to --gm-success-300
  }),
  stroke: whiteStroke
});

export const wrongStyle = new Style({
  fill: new Fill({
    color: '#f5767d', // equal to --gm-error-200
  }),
  stroke: whiteStroke
});

export const hoverStyle = new Style({
  fill: new Fill({
    color: '#d9ebf7', // equal to --atlas-light-blue
  }),
  stroke: whiteStroke
});

export const borderLayerStyle = new Style({
  stroke: new Stroke({
    color: 'white',
    width: 2
  })
});
